import AmountDepositUp from "../AmountDepositUp/AmountDepositUp";

const getEmojiByValue = (value) => {
    switch (value) {
        case 25:
            return "😌";
        case 50:
            return "😊";
        case 75:
            return "😄";
        case 100:
            return "🤩";
        default:
            return "😌"; // на случай
    }
};

const ReceiveBlock = ({ accrualAmountSum, bonusLine }) => {
    return (
        <div className="receive-info">
            <div className="d-flex ai-center">
                <p>Ви отримаєте:</p>
                <div style={{ fontSize: "24px", marginLeft: "10px" }}>
                    { getEmojiByValue(bonusLine) }
                </div>
            </div>
            <AmountDepositUp accrualAmountSum={accrualAmountSum} />
        </div>
    );
};

export default ReceiveBlock;
